import { classNames } from "../utils";

export type NotLoadedYetProps = {
  className?: string;
};

const NotLoadedYet = ({ className }: NotLoadedYetProps) => {
  return (
    <div
      className={classNames(
        "inline-flex justify-center items-center",
        "pt-0.5 pb-0.5 pr-2.5 pl-2 rounded-xl font-semibold",
        "bg-gray-100",
        className ?? "h-6 w-12"
      )}
    >
      {" "}
    </div>
  );
};

export default NotLoadedYet;
